export default "__VITE_ASSET__Bp03BWlX__"